import React, { useEffect } from 'react'
import { Container } from '@material-ui/core'
import { headRewrite } from '../function/headRewrite'
import { Helmet } from 'react-helmet-async'

export default function ArchiveBuybackLP() {
  const lineUrl = 'https://line.me/R/ti/p/@240yzqkh'

  const metaTitle = '宅配買取｜Comme des Garçons・sacai・Raf Simons ほか高価買取｜Enclopedia'
  const metaDescription = 'Comme des Garçons、sacai、Raf Simons、Maison Margiela など、モードとアーカイブに特化した宅配買取。全国対応・査定料/送料0円・最短即日査定・スピード入金。'
  const metaKeywords = '買取, 宅配買取, Comme des Garçons 買取, sacai 買取, Raf Simons 買取, Maison Margiela 買取, Yohji Yamamoto 買取, UNDERCOVER 買取, アーカイブ 買取, デザイナーズ 買取'

  useEffect(() => {
    headRewrite(metaTitle, metaDescription, metaKeywords)
  }, [])

  const toLine = () => {
    window.location.href = lineUrl
  }

  const baseImageUrl = (process.env.REACT_APP_IMAGE_URL || '') + 'subscription/'
  const kaitoriPdfUrl = `${process.env.REACT_APP_IMAGE_URL || ''}media/enclopedia_kaitori.pdf`

  const strengths = [
    { title: '高額買取', desc: '市場価値と希少性を踏まえ、モード文脈で査定。一般的なリユース基準では拾いきれない価値まで評価します。', img: baseImageUrl + 'kaitori1.png' },
    { title: 'モード特化査定', desc: 'Comme des Garçons、sacai、Raf Simons、Maison Margielaなど、デザイン背景やシーズン性を理解した査定体制。', img: baseImageUrl + 'kaitori2.png' },
    { title: '簡単手続き', desc: '申込から発送、査定、入金までをオンライン中心で完結。迷わず進められる導線設計。', img: baseImageUrl + 'kaitori3.png' },
    { title: '送料無料', desc: '宅配キットの送付、査定時の送料、キャンセル時の返送料まで明確に案内。負担なく依頼できます。', img: baseImageUrl + 'kaitori4.png' },
  ]

  const flow = [
    {
      step: '01',
      title: 'LINEから申し込み',
      desc: '宅配買取をご希望の方は、LINEから無料査定をお申し込みいただけます。',
      ctaLabel: 'LINEで無料査定を申し込む',
      ctaHref: lineUrl,
    },
    {
      step: '02',
      title: '準備',
      desc: '必要書類（本人確認）と梱包を準備。宅配キットも利用可能です。',
      ctaLabel: '申し込み書類をダウンロード',
      ctaHref: kaitoriPdfUrl,
    },
    {
      step: '03',
      title: '発送',
      desc: '査定・買取希望のお品物を梱包し、必要書類を入れた後、着払いで弊社までお送りください。送料は弊社が全て負担いたします。',
      address: '宛先 〒192-0062\n東京都八王子市東町12-8 長澤ビル5F 08号室',
    },
    { step: '04', title: '査定・入金', desc: '専門査定後に金額をご案内。承諾後は速やかに入金、キャンセル時も返送料は明示します。' },
  ]

  const trust = [
    '本人確認フローを明示',
    '査定基準の透明性',
    'キャンセル無料',
    '送料・返送料を明確に案内',
  ]

  const brands = [
    'Comme des Garçons',
    'sacai',
    'Raf Simons',
    'Maison Margiela',
    'Yohji Yamamoto',
    'Junya Watanabe',
    'Dries Van Noten',
    'Helmut Lang',
    'Issey Miyake',
    'Ann Demeulemeester',
    'UNDERCOVER',
    'Jean Paul Gaultier',
  ]

  return (
    <div className="min-h-screen bg-[#eeeeee] text-[#171717] selection:bg-[#171717] selection:text-[#eeeeee]">
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
        <link rel="canonical" href={`${typeof window !== 'undefined' ? window.location.origin : ''}/kaitori/takuhai`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Enclopedia" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={`${typeof window !== 'undefined' ? window.location.origin : ''}/kaitori/takuhai`} />
        <meta property="og:image" content={(process.env.REACT_APP_IMAGE_URL ? `${process.env.REACT_APP_IMAGE_URL}subscription/kaitori-og.jpg` : `${process.env.PUBLIC_URL || ''}/favicon.ico`)} />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '本人確認は必要ですか？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'はい。初回利用時に本人確認書類の提出が必要です。提出タイミングや必要情報は事前にご案内します。',
                },
              },
              {
                '@type': 'Question',
                name: '査定基準はどのような点を見ますか？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'ブランド、状態、希少性、シーズン性、二次流通相場など、モード文脈を踏まえて総合的に評価します。',
                },
              },
              {
                '@type': 'Question',
                name: '査定に納得できない場合はキャンセルできますか？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '可能です。キャンセル時の返送条件や費用の扱いについても事前に明確にご案内します。',
                },
              },
              {
                '@type': 'Question',
                name: '送料はかかりますか？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '宅配キットの送付、査定時の送料、キャンセル時の返送料まで、条件を明確にし負担なくご利用いただけます。',
                },
              },
            ],
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: `${typeof window !== 'undefined' ? window.location.origin : ''}/`,
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '買取',
                item: `${typeof window !== 'undefined' ? window.location.origin : ''}/kaitori`,
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: '宅配買取',
                item: `${typeof window !== 'undefined' ? window.location.origin : ''}/kaitori/takuhai`,
              },
            ],
          })}
        </script>
      </Helmet>
      <Container maxWidth={'xl'} style={{ padding: 'initial' }}>
        {/* Sticky footer CTA */}
        <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#171717]/10 bg-[#eeeeee]/90 backdrop-blur supports-[backdrop-filter]:bg-[#eeeeee]/75">
          <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-10">
            <div className="hidden sm:block">
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#171717]/55">Archive Buyback</p>
              <p className="mt-1 text-sm text-[#171717]/80">デザイナーズ・ラグジュアリー専門の宅配買取</p>
            </div>
            <a href={lineUrl} className="ml-auto inline-flex items-center justify-center border border-[#171717] bg-[#171717] px-5 py-3 text-sm tracking-[0.18em] text-[#f3f3f3] transition hover:bg-transparent hover:text-[#171717]">
              LINEで無料査定を申し込む
            </a>
          </div>
        </div>

        {/* Header */}
        <header className="border-b border-[#171717]/10">
          <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-5 sm:px-6 lg:px-10">
            <div>
              <p className="text-xs uppercase tracking-[0.38em] text-[#171717]/55">Enclopedia</p>
            </div>
            <div className="hidden md:flex items-center gap-8 text-sm text-[#171717]/65">
              <a href="#strengths" className="hover:text-[#171717]">強み</a>
              <a href="#flow" className="hover:text-[#171717]">流れ</a>
              <a href="#trust" className="hover:text-[#171717]">信頼性</a>
              <a href="#brands" className="hover:text-[#171717]">ブランド</a>
            </div>
          </div>
        </header>

        <main>
          {/* Hero */}
          <section className="relative overflow-hidden">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-20 sm:px-6 sm:py-24 lg:grid-cols-12 lg:px-10 lg:py-32">
              <div className="lg:col-span-7">
                <p className="mb-6 text-[11px] uppercase tracking-[0.38em] text-[#171717]/50">Mode For Circulation / Archive Value Resale</p>
                <h1 className="max-w-4xl text-4xl font-light leading-tight tracking-[-0.03em] sm:text-6xl lg:text-7xl">
                  アーカイブを、<br />
                  次の所有者へ。
                </h1>
                <p className="mt-8 max-w-2xl text-base leading-8 text-[#171717]/70 sm:text-lg">
                  デザイナーズ・ラグジュアリー専門の宅配買取。<br className="hidden sm:block" />
                  モードの民主化と、アーカイブファッションの価値循環を軸に、希少性と文脈を理解した査定を行います。
                </p>
                <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                  <a href={lineUrl} className="inline-flex items-center justify-center border border-[#171717] bg-[#171717] px-7 py-4 text-sm tracking-[0.2em] text-[#f3f3f3] transition hover:bg-transparent hover:text-[#171717]">
                    LINEで無料査定を申し込む
                  </a>
                  <a href="#flow" className="inline-flex items-center justify-center border border-[#171717]/20 px-7 py-4 text-sm tracking-[0.16em] text-[#171717]/75 transition hover:border-[#171717] hover:text-[#171717]">
                    宅配買取の流れを見る
                  </a>
                </div>
              </div>

              <div className="lg:col-span-5">
                <div className="relative h-full min-h-[420px] border border-[#171717]/10 bg-white/30 p-6 sm:p-8">
                  <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(23,23,23,0.02),transparent_30%,rgba(23,23,23,0.04))]" />
                  <div className="relative flex h-full flex-col justify-between">
                    <div>
                      <div className="flex items-center justify-between text-[11px] uppercase tracking-[0.28em] text-[#171717]/45">
                        <span>Curated Buyback</span>
                        <span>Since Archive</span>
                      </div>
                      <div className="mt-12 border-t border-[#171717]/10 pt-6">
                        <p className="text-sm leading-7 text-[#171717]/65">
                          Comme des Garçons、sacai、Raf Simons、Maison Margiela など、モードとアーカイブに特化した審美眼で価値を見極める宅配買取。
                        </p>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div className="flex items-start justify-between border-t border-[#171717]/10 pt-4">
                        <span className="text-sm text-[#171717]/55">Concept</span>
                        <span className="max-w-[65%] text-right text-sm text-[#171717]">モードの民主化</span>
                      </div>
                      <div className="flex items-start justify-between border-t border-[#171717]/10 pt-4">
                        <span className="text-sm text-[#171717]/55">Value</span>
                        <span className="max-w-[65%] text-right text-sm text-[#171717]">アーカイブファッションの価値循環</span>
                      </div>
                      <div className="flex items-start justify-between border-t border-[#171717]/10 pt-4">
                        <span className="text-sm text-[#171717]/55">Area</span>
                        <span className="max-w-[65%] text-right text-sm text-[#171717]">Designer / Luxury / Vintage</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Strengths */}
          <section id="strengths" className="border-t border-[#171717]/10">
            <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-10 lg:py-28">
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-4">
                  <p className="text-[11px] uppercase tracking-[0.32em] text-[#171717]/50">Strengths</p>
                  <h2 className="mt-5 text-3xl font-light tracking-[-0.03em] sm:text-4xl">
                    モードを理解する、
                    <br />
                    専門査定。
                  </h2>
                </div>
                <div className="grid grid-cols-1 gap-px bg-[#171717]/10 lg:col-span-8 sm:grid-cols-2">
                  {strengths.map((item) => (
                    <div key={item.title} className="bg-[#eeeeee] p-8 sm:p-10">
                      <img src={item.img} alt={item.title} className="mb-8 h-10 w-10 bg-[#eeeeee]" />
                      <h3 className="text-xl font-light tracking-[-0.02em]">{item.title}</h3>
                      <p className="mt-4 text-sm leading-7 text-[#171717]/68">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Flow */}
          <section id="flow" className="border-t border-[#171717]/10 bg-white/20">
            <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-10 lg:py-28">
              <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
                <div>
                  <p className="text-[11px] uppercase tracking-[0.32em] text-[#171717]/50">Flow</p>
                  <h2 className="mt-5 text-3xl font-light tracking-[-0.03em] sm:text-4xl">宅配買取の流れ</h2>
                </div>
                <p className="max-w-xl text-sm leading-7 text-[#171717]/65">
                  申込から入金まで、必要な情報だけを静かに整理。初めての利用でも迷わない、簡潔な導線で構成しています。
                </p>
              </div>

              <div className="mt-14 grid grid-cols-1 gap-px bg-[#171717]/10 md:grid-cols-2 xl:grid-cols-4">
                {flow.map((item) => (
                  <div key={item.step} className="flex min-h-[300px] flex-col justify-between bg-[#eeeeee] p-8">
                    <div>
                      <div className="flex items-center justify-between">
                        <span className="text-[11px] tracking-[0.28em] text-[#171717]/40">{item.step}</span>
                      </div>
                      <h3 className="mt-12 text-2xl font-light tracking-[-0.02em]">{item.title}</h3>
                    </div>
                    <div>
                      <p className="mt-8 whitespace-pre-line text-sm leading-7 text-[#171717]/68">{item.desc}</p>
                      {item.address && (
                        <p className="mt-4 whitespace-pre-line text-sm font-bold leading-7 text-[#171717]">
                          {item.address}
                        </p>
                      )}
                      {item.ctaHref && (
                        <a
                          href={item.ctaHref}
                          className="mt-5 inline-flex items-center justify-center border border-[#171717] bg-[#171717] px-5 py-3 text-xs tracking-[0.16em] text-[#f3f3f3] transition hover:bg-transparent hover:text-[#171717]"
                        >
                          {item.ctaLabel}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Trust */}
          <section id="trust" className="border-t border-[#171717]/10">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-20 sm:px-6 lg:grid-cols-12 lg:px-10 lg:py-28">
              <div className="lg:col-span-4">
                <p className="text-[11px] uppercase tracking-[0.32em] text-[#171717]/50">Trust</p>
                <h2 className="mt-5 text-3xl font-light tracking-[-0.03em] sm:text-4xl">
                  不安を減らす、
                  <br />
                  透明な案内。
                </h2>
              </div>

              <div className="space-y-px bg-[#171717]/10 lg:col-span-8">
                {trust.map((item, index) => (
                  <div key={item} className="flex flex-col gap-3 bg-[#eeeeee] p-7 sm:flex-row sm:items-center sm:justify-between sm:p-8">
                    <div className="flex items-center gap-4">
                      <span className="text-[11px] tracking-[0.28em] text-[#171717]/40">0{index + 1}</span>
                      <h3 className="text-lg font-light tracking-[-0.02em]">{item}</h3>
                    </div>
                    <p className="max-w-md text-sm leading-7 text-[#171717]/65">
                      {index === 0 && '本人確認書類の提出タイミングや必要情報を事前に明示し、初回利用でも不安なく進められる設計。'}
                      {index === 1 && 'ブランド、状態、希少性、シーズン性、二次流通相場など、査定の視点をできる限り可視化。'}
                      {index === 2 && '査定金額に納得できない場合はキャンセル可能。返送条件や費用の扱いもわかりやすく案内します。'}
                      {index === 3 && '送料・返送料・宅配キットの有無など、費用面を曖昧にせず明確に掲示。'}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Brands */}
          <section id="brands" className="border-t border-[#171717]/10 bg-white/20">
            <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-10 lg:py-28">
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-4">
                  <p className="text-[11px] uppercase tracking-[0.32em] text-[#171717]/50">Brands</p>
                  <h2 className="mt-5 text-3xl font-light tracking-[-0.03em] sm:text-4xl">取扱ブランド</h2>
                  <p className="mt-5 max-w-md text-sm leading-7 text-[#171717]/65">
                    デザイナーズブランド、ラグジュアリーブランド、ヴィンテージアイテムまで。文脈と市場価値を理解したうえで査定します。掲載ブランド以外にも、さまざまなデザイナーズブランド・ラグジュアリーブランド・ヴィンテージアイテムの買取を行っています。ブランド名やアイテムの詳細は、LINEよりお気軽にご相談ください。
                  </p>
                </div>
                <div className="lg:col-span-8">
                  <div className="grid grid-cols-1 gap-px bg-[#171717]/10 sm:grid-cols-2 lg:grid-cols-3">
                    {brands.map((brand) => (
                      <div key={brand} className="bg-[#eeeeee] px-6 py-5 text-sm tracking-[0.04em] text-[#171717]/88">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <section id="cta" className="border-t border-[#171717]/10 pb-24">
            <div className="mx-auto max-w-5xl px-4 py-20 text-center sm:px-6 lg:px-10 lg:py-28">
              <p className="text-[11px] uppercase tracking-[0.34em] text-[#171717]/50">Final CTA</p>
              <h2 className="mx-auto mt-5 max-w-3xl text-3xl font-light tracking-[-0.03em] sm:text-5xl">
                価値を理解できる場所へ、
                <br className="hidden sm:block" />
                静かに手放す。
              </h2>
                <p className="mx-auto mt-8 max-w-2xl text-sm leading-8 text-[#171717]/68 sm:text-base">
                  一般的なリユースでは伝わりにくい、モードとアーカイブの価値を汲み取る宅配買取。まずはLINEの無料査定からご相談ください。
                </p>
                <a href="/brand_buyback" className="mt-6 inline-flex text-sm font-bold tracking-[0.08em] text-[#171717] underline underline-offset-4">
                  ブランド別買取ページを見る
                </a>
              <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <button onClick={toLine} className="inline-flex min-w-[240px] items-center justify-center border border-[#171717] bg-[#171717] px-7 py-4 text-sm tracking-[0.2em] text-[#f3f3f3] transition hover:bg-transparent hover:text-[#171717]">
                  LINEで無料査定を申し込む
                </button>
                <a href="#trust" className="inline-flex min-w-[240px] items-center justify-center border border-[#171717]/20 px-7 py-4 text-sm tracking-[0.16em] text-[#171717]/75 transition hover:border-[#171717] hover:text-[#171717]">
                  査定基準と本人確認を見る
                </a>
              </div>
            </div>
          </section>
        </main>
      </Container>
    </div>
  )
}
